// extracted by mini-css-extract-plugin
export default {"reaction":"ContentTop_reaction__mKU5U"};